import React, { useState, useEffect } from "react";
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Axios from "axios";
import style from "./RelatorioCliente.module.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from 'notistack';

const RelatorioCliente = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [naviosList, setNaviosList] = useState([]);
  const [selectedNavio, setSelectedNavio] = useState("");
  const [periodo, setPeriodo] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true); // Estado para carregamento

  // Capturar usuário registrado do localStorage
  const getUserGrupo = () => {
    try {
      const usuario = JSON.parse(localStorage.getItem("user_token")).id;
      return usuario.split(".")[1] || null; // Pega a parte após o ponto
    } catch (error) {
      return null;
    }
  };

  const grupoCliente = getUserGrupo();

  useEffect(() => {
    if (grupoCliente) {
      getOp(grupoCliente);
    } else {
      setLoading(false); // Finaliza o carregamento caso não tenha um grupo válido
    }
  }, [grupoCliente]);

  const getOp = async (grupo) => {
    setLoading(true);
    try {
      const response = await Axios.get(`https://operacao.setlogistica.com.br/api/relatoriocliente/operacoes/${grupo}`);
      setNaviosList(response.data);
    } catch (error) {
      console.error("Erro ao buscar operações:", error);
      showAlert("Erro ao carregar dados", "error");
    } finally {
      setLoading(false);
    }
  };

  const getPeriodo = async (id) => {
    try {
      const response = await Axios.get(`https://operacao.setlogistica.com.br/api/periodos/gerais/${id}`);
      setPeriodo(response.data);
    } catch (error) {
      console.error("Erro ao buscar períodos:", error);
    }
  };

  const onSelectNavio = (e) => {
    const selectedValue = e.target.value;
    setSelectedNavio(selectedValue);
    getPeriodo(selectedValue);
  };

  const DetalhesNavio = (id, status, nome) => {
    navigate(`/relatoriocliente/${id}`);
    setList(nome);
  };

  const redirectToRelatorioPeriodo = () => {
    if (selectedNavio) {
      navigate(`/relatoriocliente/${selectedNavio}`);
    } else {
      showAlert("Por favor, selecione um navio primeiro", "error");
    }
  };

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  return (
    <>
      <Navbar relatorios />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.active}>RELATÓRIOS</div>
          </div>

          {loading ? (
            <p className={style.loading}>Carregando dados...</p>
          ) : grupoCliente ? (
            <div className={style.table}>
              <div className={style.table_outer_container}>
                <div className={style.table_container}>
                  {naviosList.length > 0 ? (
                    naviosList
                      .filter(val => val.STATUS_OPERACAO === "OPERANDO" || val.STATUS_OPERACAO === "PARALISADO")
                      .map((val, key) => (
                        <div
                          className={style.table_item}
                          key={key}
                          onClick={() => [DetalhesNavio(val.COD_OPERACAO, val.STATUS_OPERACAO, val.NOME_NAVIO), getPeriodo(val.COD_OPERACAO)]}
                        >
                          <div className={style.detalheNavio}><i className="fas fa-ship"></i> {val.NOME_NAVIO || "-"}</div>
                          <div className={style.detalheNavio}>RAP: {val.RAP || "-"}</div>
                          <div className={style.detalheNavio}>ATRACAÇÃO: {moment(val.ATRACACAO).format("DD/MM/YYYY") || "-"}</div>
                        </div>
                      ))
                  ) : (
                    <p className={style.noData}>Nenhuma operação encontrada para este grupo.</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className={style.noData}>
              <p>Não foi possível identificar o grupo do usuário.</p>
            </div>
          )}

          {grupoCliente && (
            <div className={style.dropdownContainer}>
              <select className={style.navioDropdown} value={selectedNavio} onChange={onSelectNavio}>
                <option value="">Selecione um Navio</option>
                {naviosList.map((val, key) => (
                  <option key={key} value={val.COD_OPERACAO}>{val.NOME_NAVIO || "-"}</option>
                ))}
              </select>
              <button className={style.btnRelatorio} onClick={redirectToRelatorioPeriodo}>
                Gerar Relatório
              </button>
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider anchorOrigin={{ vertical: "bottom", horizontal: "right" }} maxSnack={3} autoHideDuration={3500}>
      <RelatorioCliente />
    </SnackbarProvider>
  );
}
